import { useState } from 'react';
import { Button } from '@rsos/base-components';
import ManageMessageModal from '../modals/ManageMessageModal';

const CreateCustomMessage = () => {
  const [isCreateMessageModalOpen, setIsCreateMessageModalOpen] =
    useState(false);
  const handleManageModalClose = () => {
    setIsCreateMessageModalOpen(false);
  };

  const handleCreateMessageModalOpen = () => {
    setIsCreateMessageModalOpen(true);
  };
  return (
    <>
      <Button btnType="primary" noMargin onClick={handleCreateMessageModalOpen}>
        Create new message
      </Button>
      <ManageMessageModal
        isOpened={isCreateMessageModalOpen}
        onClose={handleManageModalClose}
      />
    </>
  );
};

export default CreateCustomMessage;
